import { createAction, createReducer, Dispatch } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';

export type ReCaptcha = {
  ready: boolean;
};

export const reCaptchaInitialState = {
  ready: false,
};

// action
const SET_RECAPTCHA_READY = 'reCaptcha/setReCaptchaReady';

export const setReCaptchaReady = createAction<
  Pick<ReCaptcha, 'ready'>,
  typeof SET_RECAPTCHA_READY
>(SET_RECAPTCHA_READY);

type SetReCaptchaReadyAction = ReturnType<typeof setReCaptchaReady>;

// dispatch
export const useSetReCaptchaReadyDispatch =
  (): Dispatch<SetReCaptchaReadyAction> =>
    useDispatch<Dispatch<SetReCaptchaReadyAction>>();

export const reCaptchaReducer = createReducer(
  reCaptchaInitialState,
  (builder) => {
    builder.addCase(setReCaptchaReady, (state, action) => {
      return {
        ...state,
        ready: action.payload.ready,
      };
    });
  },
);

// selector
export const useReCaptchaReady = (): ReCaptcha['ready'] =>
  useSelector<RootState, ReCaptcha['ready']>(
    (rootState) => rootState.reCaptcha.ready,
  );
